// export const apibase = 'http://localhost:8081/api/'

// export const apibase = 'https://preview.mypsy365.com/api/'

export const apibase = 'https://www.mypsy365.com/api/'
// export const apibase = 'http://localhost:8080/api/'

// export const apibase = 'https://www.ttxinli.com/api/'

// 根据token 获取用户信息
export const tokens = 'tokens'

export const live = 'superlive'

export const superLiveSeries = 'superliveseries'

export const collection = 'Collection'

export const user = 'user'

export const favorite = 'favorite'

export const imSigs = 'im_sigs'

export const imAccounts = 'im_accounts'

export const imGroups = 'im_groups'

export const imGroupMsgs = 'im_group_msgs'

// 同步登陆
export const spalogin = 'spa/login'

// 同步退出
export const spalogout = 'spa/logout'

export const v3 = 'v3'

// 直播2.0
export const v6Superlive = 'v6/superlive'

export const stsToken = 'aliyun/sts_token'



// WEBPACK FOOTER //
// ./src/util/api/config.js